__turbopack_context__.v({
  "calloutSection": "Le15uq_calloutSection",
  "contactModal": "Le15uq_contactModal",
  "footer": "Le15uq_footer",
  "header": "Le15uq_header",
  "privacyPolicyBanner": "Le15uq_privacyPolicyBanner",
  "root": "Le15uq_root",
});
